import {
  CloudRounded,
  StorageRounded,
  TableViewRounded,
} from "@mui/icons-material";
import FolderOpenRoundedIcon from "@mui/icons-material/FolderOpenRounded";
import { Box, Typography } from "@mui/material";
import CustomCopyButton from "../../../../../../components/CustomCopyButton";
import SvgToIcon from "../../../../../../icons/SvgToIcon";
import { icons } from "../../../icons/iconExport";
import { DataStoreResourceTypeIconsAndLabels } from "../../../utils";
import TextIntegrationStyle from "../../TextIntegrationStyle";

const AzureTableDetailsView = ({ entityData }) => {
  const tableData = entityData?.azure_table_data;

  if (!tableData) {
    return null;
  }

  const [table_logo, table_label] = Object.keys(
    DataStoreResourceTypeIconsAndLabels
  ).includes(tableData.resource_type)
    ? DataStoreResourceTypeIconsAndLabels[tableData.resource_type]
    : [null, null];

  return (
    <Box display="flex" flexDirection="column" gap={2}>
      {/* Resource Type */}
      {tableData.resource_type && (
        <Box display="flex" flexDirection="column" gap={1}>
          <Box display="flex" flexDirection="row" alignItems="center" gap={1}>
            <SvgToIcon IconLogo={icons.serverTypeIcon} width="16px" />
            <Typography variant="subtitle2">Resource Type</Typography>
          </Box>
          <Box ml={2} display="flex" alignItems="center" gap={1}>
            {table_logo && <SvgToIcon IconLogo={table_logo} width="16px" />}
            <TextIntegrationStyle
              title=""
              value={table_label || tableData.resource_type}
            />
          </Box>
        </Box>
      )}

      {/* Resource ID */}
      {tableData.resource_id && (
        <Box display="flex" flexDirection="column" gap={1}>
          <Box display="flex" flexDirection="row" alignItems="center" gap={1}>
            <SvgToIcon IconLogo={icons.serialNumberIcon} width="16px" />
            <Typography variant="subtitle2">Resource ID</Typography>
          </Box>
          <Box ml={2} display="flex" alignItems="center" gap={2}>
            <TextIntegrationStyle title="" value={tableData.resource_id} />
            <CustomCopyButton
              copyTitle="Resource ID"
              copyText={tableData.resource_id}
            />
          </Box>
        </Box>
      )}

      {/* Storage Account */}
      {tableData.storage_account_name && (
        <Box display="flex" flexDirection="column" gap={1}>
          <Box display="flex" flexDirection="row" alignItems="center" gap={1}>
            <StorageRounded sx={{ width: "16px" }} />
            <Typography variant="subtitle2">Storage Account</Typography>
          </Box>
          <Box ml={2} display="flex">
            <TextIntegrationStyle
              title=""
              value={tableData.storage_account_name}
            />
          </Box>
        </Box>
      )}

      {/* Table Name */}
      {tableData.table_name && (
        <Box display="flex" flexDirection="column" gap={1}>
          <Box display="flex" flexDirection="row" alignItems="center" gap={1}>
            <TableViewRounded sx={{ width: "16px" }} />
            <Typography variant="subtitle2">Table Name</Typography>
          </Box>
          <Box ml={2} display="flex">
            <TextIntegrationStyle title="" value={tableData.table_name} />
          </Box>
        </Box>
      )}

      {/* Resource Group */}
      {tableData.resource_group_name && (
        <Box display="flex" flexDirection="column" gap={1}>
          <Box display="flex" flexDirection="row" alignItems="center" gap={1}>
            <FolderOpenRoundedIcon sx={{ width: "16px" }} />
            <Typography variant="subtitle2">Resource Group</Typography>
          </Box>
          <Box ml={2} display="flex">
            <TextIntegrationStyle
              title=""
              value={tableData.resource_group_name}
            />
          </Box>
        </Box>
      )}

      {/* Location */}
      {tableData.location && (
        <Box display="flex" flexDirection="column" gap={1}>
          <Box display="flex" flexDirection="row" alignItems="center" gap={1}>
            <SvgToIcon IconLogo={icons.regionServerIcon} width="16px" />
            <Typography variant="subtitle2">Location</Typography>
          </Box>
          <Box ml={2} display="flex">
            <TextIntegrationStyle title="" value={tableData.location} />
          </Box>
        </Box>
      )}

      {/* Subscription */}
      {tableData.subscription_name && (
        <Box display="flex" flexDirection="column" gap={1}>
          <Box display="flex" flexDirection="row" alignItems="center" gap={1}>
            <CloudRounded sx={{ width: "16px" }} />
            <Typography variant="subtitle2">Subscription</Typography>
          </Box>
          <Box ml={2} display="flex">
            <TextIntegrationStyle
              title=""
              value={tableData.subscription_name}
            />
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default AzureTableDetailsView;
